var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings"},[_c('Navbar',{attrs:{"title":"设置"}}),_c('div',{staticClass:"content"},[_c('settingListField',{attrs:{"list":_vm.settingList}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }